var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 7C20.2985 7 20 7.37702 20 7.84211C20 8.30719 20.2985 8.68421 20.6667 8.68421H21.6667V22.1579C21.6667 22.623 21.9651 23 22.3333 23C22.7015 23 23 22.623 23 22.1579V7.84211C23 7.37702 22.7015 7 22.3333 7H20.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82051 12.2174C3.36736 12.2174 3 12.5678 3 13V21.2174C3 21.6496 3.36736 22 3.82051 22H5.8718C6.32495 22 6.69231 21.6496 6.69231 21.2174V13C6.69231 12.5678 6.32495 12.2174 5.8718 12.2174H3.82051Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 22C7.88018 22 7.51282 21.6496 7.51282 21.2174V4.78261C7.51282 4.35039 7.88018 4 8.33333 4H18.1795C18.6326 4 19 4.35039 19 4.78261V21.2174C19 21.6496 18.6326 22 18.1795 22H15.8177C15.3646 22 14.9972 21.6496 14.9972 21.2174V18.9208C14.9972 18.4885 14.6299 18.1382 14.1767 18.1382H12.4102C11.957 18.1382 11.5897 18.4886 11.5897 18.9208V21.2174C11.5897 21.6496 11.2223 22 10.7692 22H8.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationIcon);
export default __webpack_public_path__ + "static/media/OrganisationIcon.ffbcf9ef5edecde0375d9e4b858cc146.svg";
export { ForwardRef as ReactComponent };